import React from "react"

function Factory({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line x1="8" y1="8" x2="15.5" y2="8" stroke="#003E4C" strokeWidth="1" strokeLinecap="round" />
      <path
        d="M9.5 8.5V27"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 8.5V17.5L20.5 13.5V18L27 14V27"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 27H26C26.55 27 27 26.55 27 26V27"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="17.5"
        y="21.5"
        width="3"
        height="3"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="22.5"
        y="21.5"
        width="3"
        height="3"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Factory
